<div class="relative isolate w-max">
  <rid-audio-bubble class="absolute" [color]="'bg-white/50'" #audioBubble />

  <button
    class="relative inline-block cursor-pointer border-4 transition-colors outline-none select-none active:shadow-[0_0_0]"
    [class]="twClasses()"
    [disabled]="isPlaying()"
    (click)="hasRecording() ? playback() : isRecording() ? stopRecording() : record()"
  >
    @if (hasRecording()) {
      <i-play [class]="{ LARGE: 'size-32', SMALL: 'size-16', MEDIUM: 'size-20' }[size()]" animate.enter="anim-pop-in" />
    } @else if (isRecording()) {
      <i-stop [class]="{ LARGE: 'size-32', SMALL: 'size-16', MEDIUM: 'size-20' }[size()]" animate.enter="anim-pop-in" />
    } @else {
      <i-microphone [class]="{ LARGE: 'size-32', SMALL: 'size-16', MEDIUM: 'size-20' }[size()]" animate.enter="anim-pop-in" />
    }
  </button>
</div>
